import { getTodayProjection } from "@/lib/api/today";
import type { TodayProjection } from "@/lib/api/projection-types";
import { createProjectionStore } from "./createProjectionStore";

export const useTodayProjectionStore = createProjectionStore<TodayProjection, []>(
  getTodayProjection,
  []
);
